import appIdParameter from '@/consts/appIdParameterConfig.const.js';
import webAnalyticsProvider from '@/providers/webAnalytics.provider';
import sessionUtils from '@/utils/session.utils';
import store from '@/store';

const APP_NAME = 'PIX';

/**
 * Function that returns a plain object suitable for the AddUserAccess request
 * @param {string} pageName Name of the module from which the user access is executed
 * @returns an object of the AddUserAccessDTO
 */
const getAddUserAccessDTO = function (page, eventName) {
  return {
    user: store.getters['authModule/UserName'],
    appId: appIdParameter.PIX,
    page,
    eventName,
    instance: store.getters['authModule/fullInstance'],
    sessionId: sessionUtils.getOrCreateSessionId(),
  };
};

/**
 * const that returns a plain object suitable for the logErrorProvisionalName request
 */
const getSaveLogDTO = function (messageType, message, messageCode, stackTrace, endpoint, responseBody) {
  return {
    appPage: window.location.pathname,
    user: store.getters['authModule/UserName'],
    system: APP_NAME,
    relationId: sessionUtils.getOrCreateSessionId(),
    message,
    messageType,
    messageCode,
    stackTrace,
    endpoint,
    responseBody,
  };
};

const registerWebAnalyticsEvent = (eventName, page = window.location.pathname) => {
  webAnalyticsProvider.addUserAccess(getAddUserAccessDTO(page, eventName));
};

export default {
  registerWebAnalyticsEvent,
  getAddUserAccessDTO,
  getSaveLogDTO,
};
